import { useQuery } from '@apollo/client';
import { GET_DESTINATION } from 'queries';

const DEFAULT_LANG = 'hr';

function toPrismicLang(locale: string) {
  if (locale === 'en') return 'en-eu';
  if (locale === 'de') return 'de-de';
  if (locale === 'sr') return 'rs';
  return locale;
}

export const usePrismicDestination = (locale: string, uid: string) => {
  const lang = toPrismicLang(locale);

  const primary = useQuery(GET_DESTINATION, { variables: { uid, lang } });
  const primaryNode: PrismicDocument['node'] | undefined =
    primary.data?.document;

  const fallback = useQuery(GET_DESTINATION, {
    variables: { uid, lang: DEFAULT_LANG },
    skip: lang === DEFAULT_LANG || primary.loading || !!primaryNode,
  });
  const fallbackNode: PrismicDocument['node'] | undefined =
    fallback.data?.document;

  const node = primaryNode || fallbackNode;
  const document: PrismicDocument | undefined = node ? { node } : undefined;

  return {
    document,
    loading: primary.loading || fallback.loading,
    error: primary.error || fallback.error,
  };
};
